<form
    [formGroup]="tagFormGroup"
    (ngSubmit)="addTag()"
    class="modal-wrapper">
    <div class="modal-header">
        <h2
            class="modal-title"
            id="exampleModalLabel">
            New tag
        </h2>
        <button
            type="button"
            class="close"
            aria-label="Close"
            (click)="activeModal.dismiss()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body">
        <div class="row">
            <div class="col">
                <div class="form-group m-b-2">
                    <label for="name">Tag name </label>
                    <small
                        class="form-error"
                        *ngIf="!tagFormGroup.get('name').valid && tagFormGroup.get('name').touched"
                        >please enter a name for the tag</small
                    >
                    <input
                        id="name"
                        formControlName="name"
                        type="text"
                        placeholder="Enter a new tag name" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="form-group m-b-2">
                    <label for="list">List</label>
                    <select
                        id="list"
                        formControlName="list">
                        <option
                            *ngFor="let list of lists"
                            [ngValue]="list.id">
                            {{ list.name }}
                        </option>
                    </select>
                </div>
            </div>
        </div>
    </div>

    <div class="modal-footer">
        <app-missing-fields [form]="tagFormGroup"></app-missing-fields>
        <input
            [ngClass]="!tagFormGroup.valid ? 'button button--disabled w-100' : 'button button--primary w-100'"
            type="submit"
            value="Add"
            [disabled]="!tagFormGroup.valid" />
    </div>
</form>
